export default __webpack_public_path__ + "static/media/logoa4.8ac63c97.png";